import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OfficialsRoutingModule } from './officials-routing.module';
import { BootstrapOfficialsComponent } from './components/bootstrap-officials/bootstrap-officials.component';
import { FiltersofficialsService } from './services/filtersofficials.service';
import { CommonPageComponentsModule } from '../common-page-components/common-page-components.module';
import { ServicesModule } from 'world-archery-lib';
import { CoreModule } from '../library/core.module';

@NgModule({
  declarations: [BootstrapOfficialsComponent],
  imports: [
    CommonModule,
    OfficialsRoutingModule,
    CommonPageComponentsModule,
    ServicesModule,
    CoreModule
  ],
  providers:[
    FiltersofficialsService
  ]
})
export class OfficialsModule { }
